import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  existOfModule = new Subject<string>();

  constructor() { }
}
